import React from 'react'
import PropTypes from 'prop-types'
import { useField } from 'formik'
import { Box } from 'reflexbox/styled-components'

import { HiddenRadio, StyledRadio } from './styles'

// TODO: Error state
const Radio = ({ label, className, ...props }) => {
  const [field] = useField(props)

  const checked = field.value === props.value

  return (
    <Box mr='24px' mb='8px' display='inline-flex' alignItems='center' as='label' className={className} {...props}>
      <HiddenRadio checked={checked} {...field} {...props} />

      <StyledRadio checked={checked} />
      {label}
    </Box>
  )
}

Radio.propTypes = {
  label: PropTypes.string.isRequired,
  ...Box.propTypes,
}

export default Radio
